"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPageWidgetDataSchema = exports.ProductPageItemSchema = exports.ProductPageDetailItemSchema = exports.ProductPageLogMetaSchema = exports.ProductPageExpMetaSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.ProductPageExpMetaSchema = zod_1.z.object({
    expCatalog: zod_1.z.string().nullable(),
    expChannel: zod_1.z.string(),
    expChannelTitle: zod_1.z.string().optional(),
    expContentsType: zod_1.z.nullable(zod_1.z.enum(['GUESTHOUSE', 'HOTEL', 'MOTEL', 'PENSION'])),
    expCustomLogs: zod_1.z.optional(zod_1.z.object({})),
    expDynamicConfig: zod_1.z.optional(zod_1.z.nullable(zod_1.z.object({}))),
    expElementInputType: zod_1.z.enum(['ARTICLE', 'KEYWORD', 'LEISURE', 'NONE', 'PLACE', 'PROFILE', 'TRAIN']),
    expElementOutputType: zod_1.z.enum(['ARTICLE', 'KEYWORD', 'LEISURE', 'NONE', 'PLACE', 'PROFILE', 'TRAIN']),
    expElementType: zod_1.z.enum(['ARTICLE', 'LEISURE', 'NONE', 'PLACE']),
    expGroup: zod_1.z.string().optional(),
    expGroupNo: zod_1.z.number().optional(),
    expKindOfApi: zod_1.z.string().optional(),
    expLabel: zod_1.z.string().nullable(),
    expLabelCode: zod_1.z.string().nullable(),
    expLabelType: zod_1.z.string().nullable(),
    expLabelId: zod_1.z.string().optional(),
    expMethodName: zod_1.z.string().optional(),
    expMethodVersion: zod_1.z.string().optional(),
    expReferrer: zod_1.z.string().nullable(),
    expSource: zod_1.z.string(),
    expSpecifier: zod_1.z.string(),
    expSpecifierActual: zod_1.z.string(),
    expTimestamp: zod_1.z.number().optional(),
    expWidget: zod_1.z.string(),
    expWidgetPosition: zod_1.z.number().optional(),
    expWidgetSubTitle: zod_1.z.string().nullable(),
    expWidgetTitle: zod_1.z.string().nullable(),
});
exports.ProductPageLogMetaSchema = common_1.WidgetLogMeta.extend({
    object: zod_1.z.string(),
    objectType: zod_1.z.string(),
    deusGroupId: zod_1.z.string().nullable(),
    widgetPosition: zod_1.z.number().nullable(),
    districtCode: zod_1.z.string().optional(),
});
exports.ProductPageDetailItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    action: common_1.CommonResponseItemActionDto,
    image: common_1.CommonResponseItemImageDto,
    title: common_1.CommonResponseItemPropertyDto,
    position: zod_1.z.object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
    }),
    discountBadge: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    locationDescription: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    ranking: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    review: zod_1.z.nullable(common_1.CommonResponseItemReviewDto),
    caption: zod_1.z.nullable(common_1.CommonResponseItemCaptionDto),
    badges: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemPropertyDto)),
    description: zod_1.z.nullable(common_1.CommonResponseItemPropertyDto),
    location: zod_1.z.nullable(zod_1.z.object({})),
    benefits: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemBenefitDto)),
    availableQuantity: common_1.CommonResponseItemBenefitDto.nullable(),
    features: zod_1.z.array(zod_1.z.nullable(common_1.CommonResponseItemPropertyDto)),
    prices: zod_1.z.array(zod_1.z.array(common_1.CommonResponseItemPropertyDto)),
    notices: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
    memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    logMeta: common_1.CommonItemLogMetaDto,
});
exports.ProductPageItemSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        title: zod_1.z.string(),
    })
        .nullish(),
    items: zod_1.z.array(exports.ProductPageDetailItemSchema),
    logMeta: zod_1.z.object({
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        widgetTabPosition: zod_1.z.number().nullable(),
        widgetTabTitle: zod_1.z.string().nullable(),
    }),
});
/**
 * 상품형 페이지 위젯 응답 스키마
 * [V3] 상품형 큐레이션 위젯 - 페이지형 (YDM__NOL_CURATED_PRODUCT_PAGE__V1)
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/CXT/pages/493291514/YDM__NOL_CURATED_PRODUCT_PAGE__V1+-+page+9.0.0~}
 * [V1] 추천 상품 페이지형 위젯 (YDM__NOL_RECOMMENDED_PRODUCT_PAGE__V1)
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/CXT/pages/464093569/YDM__NOL_RECOMMENDED_PRODUCT_PAGE__V1+9.0.0~}
 */
exports.ProductPageWidgetDataSchema = zod_1.z.object({
    expMeta: exports.ProductPageExpMetaSchema.optional(),
    header: zod_1.z
        .object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string().optional(),
        icon: zod_1.z.string().optional(),
        badge: zod_1.z
            .object({
            type: zod_1.z.string().optional(),
            title: zod_1.z.string().optional(),
            action: zod_1.z
                .object({
                type: zod_1.z.string().optional(),
                value: zod_1.z.string().optional(),
            })
                .optional(),
        })
            .optional(),
        more: zod_1.z
            .object({
            title: zod_1.z.string(),
            action: zod_1.z.object({
                app: zod_1.z.string(),
                web: zod_1.z.string(),
            }),
            logMeta: zod_1.z.object({
                object: zod_1.z.string(),
                objectType: zod_1.z.string(),
            }),
        })
            .optional(),
    })
        .nullish(),
    items: zod_1.z.array(exports.ProductPageItemSchema),
    logMeta: exports.ProductPageLogMetaSchema,
});
